import { type Board, BoardSchema } from '../model/schema'

export interface ColumnDto {
  id: string
  name: string
  position: number
  counts_time: boolean
  done: boolean
  waiting: boolean
}

export interface BoardDto {
  id: string
  owner_kind?: string
  owner_id?: string
  project_id?: string
  name: string
  departments: string[]
  position?: number
  customer_visible?: boolean
  customer_visible_by?: string
  customer_visible_at?: string
  customer_all_tasks?: boolean
  columns: ColumnDto[]
}

export function toBoard(dto: BoardDto): Board {
  return BoardSchema.parse({
    id: dto.id,
    // Источник без владельца — доска проектная: ровно так вели себя все доски до
    // появления владельцев.
    owner: { kind: dto.owner_kind ?? 'project', id: dto.owner_id ?? dto.project_id ?? '' },
    projectId: dto.project_id ?? '',
    name: dto.name,
    departments: dto.departments ?? [],
    ...(dto.position !== undefined ? { position: dto.position } : {}),
    // Нет поля — доска закрыта для заказчика: безопасный дефолт, пока источник
    // не выкатил флаг.
    customerVisible: dto.customer_visible ?? false,
    customerVisibleBy: dto.customer_visible_by ? dto.customer_visible_by : null,
    customerVisibleAt: dto.customer_visible_at ?? null,
    customerAllTasks: dto.customer_all_tasks ?? false,
    columns: [...dto.columns]
      .sort((a, b) => a.position - b.position)
      .map((c) => ({
        id: c.id,
        name: c.name,
        position: c.position,
        countsTime: c.counts_time,
        done: c.done,
        waiting: c.waiting,
      })),
  })
}
